import { Box, Typography } from "@mui/material";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  groupId: string | null;
  isPending: boolean;
};

const CancelWorkOrderGroupModal = ({
  open,
  onClose,
  onConfirm,
  groupId,
  isPending,
}: Props) => (
  <Modal
    open={open}
    onClose={isPending ? undefined : onClose}
    disableEscapeKeyDown={isPending}
  >
    <>
      <Typography variant="h2" textAlign="center">
        {`Cancel work order group ${groupId ?? ""}`}
      </Typography>
      <Box mt={8} mb={2}>
        <Typography color="textSecondary" textAlign="center">
          Are you sure you want to cancel this work order group? It will mark
          all work order tickets as &quot;Canceled&quot; for every condition in
          the group, regardless of current status.
        </Typography>
      </Box>
      <Box mt={8} display="flex" justifyContent="center">
        <Box mr={1}>
          <Button color="secondary" onClick={onClose} disabled={isPending}>
            Go Back
          </Button>
        </Box>
        <Button color="primary" onClick={onConfirm} disabled={isPending}>
          {isPending ? "Canceling..." : "Confirm"}
        </Button>
      </Box>
    </>
  </Modal>
);

export default CancelWorkOrderGroupModal;
